import { defineMigrations } from "@supersig/store";
import { cssTypeMap } from "../../primitives";
import { createResourceId } from "../records";
/** @public */ export const fontFaceResourceProps = {
    fontFace: cssTypeMap["css-font"]
};
export const isFontFaceResource = (resource)=>{
    if (resource.typeName !== "resource") return false;
    return resource.type === "font_face";
};
export const fontFaceResourceNameFromProps = (props)=>{
    const { fontFace: { value, weight, variant, style } } = props;
    return `v1;${value};${weight};${variant};${style}`;
};
export const parseFontFamilyResourceName = (name)=>{
    const parts = name.split(";");
    if (parts.length !== 5) return undefined;
    if (parts[0] !== "v1") return undefined;
    const [_, value, weight, variant, style] = parts;
    return {
        value,
        weight,
        variant,
        style
    };
};
export const createFontFaceResource = (props, { organizationId, scope, version = 0 })=>{
    const type = "font_face";
    const name = fontFaceResourceNameFromProps(props);
    return {
        id: createResourceId({
            type,
            name,
            organizationId,
            scope
        }),
        typeName: "resource",
        type,
        props: props,
        scope,
        version,
        organizationId,
        name,
        meta: {}
    };
};
/** @internal */ export const fontFaceResourceMigrations = defineMigrations({});
export const SWFontFaceResourceInfo = {
    migrations: fontFaceResourceMigrations,
    props: fontFaceResourceProps,
    meta: {}
};
